export const VALID_SECTION_CODES = {
  PERSUATION: 'PRS',
  LOGIN: 'LOGIN',
  DYK: 'DYK',
  INQ: 'INQ',
  RECENTLY_VIEWED: 'RVS',
  PDO: 'PDO',
  BLACK: 'BLACK',
  ADDON: 'ADDON',
};

export const CUSTOM_SECTIONS = {
  CONTENT_CARD: 'content_card',
  ADDS: 'DYNAD',
};
